module.exports = __webpack_public_path__ + "images/help/icn-faq-ding@2x-ce66663b6b04469146e9db497e207fda.png";